'use strict';

var windowDefined = typeof window !== 'undefined';
var environment = windowDefined ? 'browser' : 'server';

module.exports = {
  environment: environment,
  isServer: environment === 'server',
  isBrowser: environment === 'browser'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/core/environment.js
 ** module id = 102
 ** module chunks = 0
 **/